export default "__VITE_ASSET__CFa6kJZK__"